import { StatsigProvider } from '@statsig/react-bindings';
import { BrowserRouter } from 'react-router-dom';

import AppWrapper from './App';
import { ApplicationLoader } from './components/ApplicationLoader/ApplicationLoader';
import { DatadogRouteTracker } from './observability/datadog';
import useAsyncClient from './statsig/client';
import { SDKProvider } from './utils/sdk';

function AppBrowserRouter() {
  const { isLoading: statsigLoading, client: statsigClient } = useAsyncClient();

  return (
    <BrowserRouter>
      <StatsigProvider client={statsigClient}>
        <SDKProvider>
          <DatadogRouteTracker />
          {statsigLoading ? (
            <div className="App">
              <ApplicationLoader />
            </div>
          ) : (
            <AppWrapper />
          )}
        </SDKProvider>
      </StatsigProvider>
    </BrowserRouter>
  );
}

export default AppBrowserRouter;
